import { CustomCard } from '@/components';
import { PATH } from '@/constants';
import { LanguageStatus } from '@/constants/enum';
import { findLanguage } from '@/helpers';
import useConfirmationNavigate from '@/hooks/useConfirmationNavigate';
import { DETECTION_LABELS } from '@/pages/Languages/languages.config';
import { useGetLanguagesQuery } from '@/redux/api/api.caller';
import { Button, Text } from '@shopify/polaris';

const LANGUAGE_ILLUSTRATION =
  'https://media.synctrack.io/megamind-ordertracking/uploads/2026/06/d2bba120-f89a-4908-9703-6f920b08edde.png';

const LanguageSection = () => {
  const navigate = useConfirmationNavigate();
  const { data } = useGetLanguagesQuery();
  const list = data?.data;

  const publishedCount = list ? list.languages.filter((l) => l.status !== LanguageStatus.Unpublished).length : 0;
  const defaultName = list?.defaultLanguage ? findLanguage(list.defaultLanguage)?.label || list.defaultLanguage : '—';
  const detection = list ? DETECTION_LABELS[list.detectionMethod] : '';

  return (
    <CustomCard
      title={
        <div className="d-flex flex-column gap-4">
          <span>Languages</span>
          <Text as="p" variant="bodyMd" tone="subdued">
            Translate your tracking page so international visitors see it in their own language.
          </Text>
          {list && (
            <Text as="p" variant="bodyMd" tone="subdued">
              <Text as="span" variant="bodyMd" fontWeight="semibold">
                {publishedCount}
              </Text>{' '}
              published {publishedCount === 1 ? 'language' : 'languages'} {' · '}Default:{' '}
              <Text as="span" variant="bodyMd" fontWeight="semibold">
                {defaultName}
              </Text>{' '}
              {' · '}Detection:{' '}
              <Text as="span" variant="bodyMd" fontWeight="semibold">
                {detection}
              </Text>
            </Text>
          )}
          <div style={{ marginTop: 8 }}>
            <Button onClick={() => navigate(PATH.LANGUAGES)}>Manage languages</Button>
          </div>
        </div>
      }
      noHeaderBorder
      headerStyles={{ alignItems: 'flex-start' }}
      actionGroup={[
        {
          content: (
            <img
              src={LANGUAGE_ILLUSTRATION}
              alt="Tracking page translated into multiple languages"
              style={{ width: 300, maxWidth: '40%', height: 'auto', flexShrink: 0 }}
            />
          ),
        },
      ]}
    />
  );
};

export default LanguageSection;
